var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulkQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.38889 24.8889C7.96667 24.8889 6.54444 23.6444 5.83333 23.1111C2.27778 20.6222 1.21111 19.7333 0.5 19.2V26.6667C0.5 27.6483 1.29611 28.4444 2.27778 28.4444H16.5C17.4817 28.4444 18.2778 27.6483 18.2778 26.6667V19.2C17.5667 19.7333 16.5 20.6222 12.9444 23.1111C12.2333 23.6444 10.8111 24.8889 9.38889 24.8889ZM16.5 14.2222H2.27778C1.29611 14.2222 0.5 15.0183 0.5 16V16.8889C1.92222 17.9556 1.74444 17.9556 6.9 21.6889C7.43333 22.0444 8.5 23.1111 9.38889 23.1111C10.2778 23.1111 11.3444 22.0444 11.8778 21.8667C17.0333 18.1333 16.8556 18.1333 18.2778 17.0667V16C18.2778 15.0183 17.4817 14.2222 16.5 14.2222ZM30.7222 8.88889H12.9444C11.9628 8.88889 11.1667 9.685 11.1667 10.6667V12.4444H16.5C18.345 12.4444 19.8661 13.8567 20.0394 15.6567L20.0556 15.6444V23.1111H30.7222C31.7039 23.1111 32.5 22.315 32.5 21.3333V10.6667C32.5 9.685 31.7039 8.88889 30.7222 8.88889ZM28.9444 16H25.3889V12.4444H28.9444V16ZM9.38889 10.6667C9.38889 8.70611 10.9839 7.11111 12.9444 7.11111H25.3889V1.77778C25.3889 0.796111 24.5928 0 23.6111 0H5.83333C4.85167 0 4.05556 0.796111 4.05556 1.77778V12.4444H9.38889V10.6667Z",
    fill: "#6F6F67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28.4444,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkQuestionIcon);
export default __webpack_public_path__ + "static/media/bulk-question-icon.46d4e6fa7afa21eeab6f82a1ad52d62f.svg";
export { ForwardRef as ReactComponent };